import { createApp } from 'vue'
import App from './App.vue'
import 'vant/es/toast/style';
import router from './router'
import store from './store'
import 'amfe-flexible'
import { Button,Image as VanImage,Icon,List,DatePicker,Popup,NavBar,IndexBar,IndexAnchor} from 'vant'
import "@/assets/global.css"
import 'vant/es/image-preview/style';

// Vue.use(Button)

createApp(App).use(store).use(VanImage,Icon,Button,List,DatePicker,Popup,NavBar,IndexBar,IndexAnchor).use(router).mount('#app')
